import useAuth from 'hooks/useAuth';
import useEnums from 'hooks/useEnum';

const useRoleChecks = () => {
  const { activeRole } = useAuth();
  const { UserRolesEnum } = useEnums();

  const roleType = activeRole?.user_role_type_id ?? 0;

  const isAboveCompanyManager = roleType > UserRolesEnum.COMPANY_MANAGER;
  const isAboveSystemSupport = roleType > UserRolesEnum.SYSTEM_SUPPORT;

  return { isAboveCompanyManager, isAboveSystemSupport };
};

export default useRoleChecks;
